/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Scope_TitleInputs */

const en_svc_rag_scope_title = /** @type {(inputs: Svc_Rag_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What a RAG system is for.`)
};

const lv_svc_rag_scope_title = /** @type {(inputs: Svc_Rag_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kam vajadzīga RAG sistēma.`)
};

/**
* | output |
* | --- |
* | "What a RAG system is for." |
*
* @param {Svc_Rag_Scope_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_scope_title = /** @type {((inputs?: Svc_Rag_Scope_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Scope_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_scope_title(inputs)
	return en_svc_rag_scope_title(inputs)
});